export const SET_USER = 'SET_USER'
export const SET_USERS = 'SET_USERS'
export const SET_FIREBASE_USER = 'SET_FIREBASE_USER'
